export const UPDATE_SECHUDLE = 'UPDATE_SECHUDLE'
export const UPDATE_SECHUDLE_SUCCESS = 'UPDATE_SECHUDLE_SUCCESS'
export const UPDATE_SECHUDLE_FAILURE = 'UPDATE_SECHUDLE_FAILURE'
